import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Touristbushirepune() {



const cardData =
{
  keyword: 'Tourist Bus Hire Pune',
  heading: 'Sanavi Travels: Tourist Bus Hire Pune',
  headingDescription: 'Sanavi Travels offers premium and highly reliable Tourist Bus Hire Pune services designed for families, tourist groups, corporate travelers, students, wedding guests, and leisure travelers exploring Pune and nearby destinations. Pune is a major travel hub with easy access to hill stations, heritage sites, pilgrimage centers, beaches, and wildlife destinations, making organized group travel essential for comfort and convenience. Our tourist bus hire service in Pune is ideal for sightseeing tours, weekend getaways, school and college excursions, corporate offsite trips, destination weddings, and long outstation journeys.',

  top: 'Popular Tourist Travel Experiences with Tourist Bus Hire Pune',

  "topPlaces": [
    {
      "title": "Pune City Sightseeing Tours",
      "description": "Tourist bus hire in Pune is ideal for exploring popular city attractions such as Shaniwar Wada, Aga Khan Palace, Sinhagad Fort, Parvati Hill, and local museums. Traveling by tourist bus allows groups to visit multiple landmarks comfortably in a single day without worrying about parking, navigation, or traffic stress."
    },
    {
      "title": "Hill Station Trips from Pune",
      "description": "Pune serves as a gateway to famous hill stations like Lonavala, Khandala, Mahabaleshwar, Panchgani, and Matheran. Hiring a tourist bus ensures safe hill driving, comfortable seating, and group coordination, especially during monsoon and peak tourist seasons."
    },
    {
      "title": "Religious & Pilgrimage Tours",
      "description": "Tourist buses are widely used for pilgrimage trips from Pune to destinations like Shirdi, Pandharpur, Bhimashankar, Jejuri, Ashtavinayak temples, and other sacred sites. Group bus travel offers convenience, discipline, and peaceful travel for devotees."
    },
    {
      "title": "Corporate Tours & Offsite Travel",
      "description": "Companies in Pune frequently organize corporate outings, team-building trips, and offsite meetings. Tourist bus hire ensures punctual transportation, professional travel management, and comfortable journeys for employees and management."
    },
    {
      "title": "School & College Excursions",
      "description": "Educational institutions prefer tourist buses for school picnics, college industrial visits, and educational tours. Buses provide safe seating, supervised group travel, and reliable scheduling for students and teachers."
    },
    {
      "title": "Family & Group Vacations",
      "description": "Large families and group travelers choose tourist buses to travel together, enjoy shared experiences, and avoid coordination issues associated with multiple vehicles."
    },
    {
      "title": "Wedding & Event Guest Transport",
      "description": "Tourist bus hire is commonly used to transport wedding guests and event attendees between venues, hotels, and destinations, ensuring smooth logistics and on-time arrivals."
    },
    {
      "title": "Outstation Tourist Travel",
      "description": "For long-distance tourist travel from Pune to Goa, Konkan, Aurangabad, Nashik, or Mumbai, tourist buses provide comfort, luggage space, and a relaxed travel environment."
    },
    {
      "title": "Weekend Getaways",
      "description": "Tourist buses are ideal for weekend trips from Pune, allowing groups to leave together, maximize sightseeing time, and return safely without driving fatigue."
    },
    {
      "title": "Stress-Free Group Coordination",
      "description": "Traveling in a single tourist bus eliminates convoy risks, parking issues, and communication gaps, making group travel smooth and enjoyable."
    }
  ],

  "services": [
    {
      "name": "Tourist Bus Hire Pune",
      "description": "Sanavi Travels provides comprehensive tourist bus hire services in Pune for sightseeing, leisure travel, corporate tours, family vacations, and outstation journeys. Our buses are clean, spacious, and driven by experienced chauffeurs who understand tourist requirements, ensuring safe, comfortable, and well-coordinated group travel."
    },
    {
      "name": "AC Tourist Bus Hire Pune",
      "description": "AC tourist buses offer a cool and comfortable travel experience, especially suitable for long-distance journeys, summer travel, and premium tourist groups."
    },
    {
      "name": "Non AC Tourist Bus Hire Pune",
      "description": "Non AC tourist buses provide an economical solution for budget-conscious groups while maintaining safety and comfort standards."
    },
    {
      "name": "Luxury Tourist Bus Hire Pune",
      "description": "Luxury tourist buses feature premium interiors, pushback seats, and enhanced ride quality, ideal for corporate tours, destination weddings, and VIP travel."
    },
    {
      "name": "Mini Bus for Tourist Travel Pune",
      "description": "Mini buses are suitable for small groups, families, and private tours, offering flexibility and easy maneuvering."
    },
    {
      "name": "32 Seater Tourist Bus Pune",
      "description": "32 seater tourist buses are perfect for medium-sized groups, providing balanced seating capacity and comfortable long-distance travel."
    },
    {
      "name": "35 Seater Tourist Bus Hire Pune",
      "description": "35 seater buses are ideal for large tourist groups, school trips, and corporate outings requiring group coordination."
    },
    {
      "name": "Tourist Bus for Family Pune",
      "description": "Family tourist buses ensure safe, relaxed travel for all age groups, including children and senior citizens."
    },
    {
      "name": "Tourist Bus for Corporate Pune",
      "description": "Corporate tourist buses support organized travel for meetings, conferences, offsite trips, and employee outings."
    },
    {
      "name": "Affordable Tourist Bus Rental Pune",
      "description": "Affordable rental packages help groups manage travel budgets without compromising reliability or safety."
    },
    {
      "name": "Best Tourist Bus Service Pune",
      "description": "Sanavi Travels is recognized as a trusted and reliable tourist bus service provider in Pune."
    },
    {
      "name": "Tourist Bus with Driver Pune",
      "description": "All tourist bus rentals include professional drivers experienced in tourist routes and highway travel."
    },
    {
      "name": "Tourist Bus for Wedding Pune",
      "description": "Wedding guest transportation is managed efficiently using tourist buses with coordinated schedules."
    },
    {
      "name": "Tourist Bus for Picnic Pune",
      "description": "Tourist buses are ideal for picnic travel, allowing groups to relax and enjoy the journey together."
    },
    {
      "name": "Tourist Bus for Outstation Pune",
      "description": "Outstation tourist bus services ensure comfortable long-distance travel with planned breaks and safe driving."
    }
  ],

  "tableData": [
    ["Tourist Bus Hire Pune", "AC Tourist Bus"],
    ["Non AC Tourist Bus", "Luxury Tourist Bus"],
    ["32 Seater Bus", "35 Seater Bus"],
    ["Family Travel", "Corporate Tours"],
    ["Picnic Trips", "Outstation Travel"]
  ],

  "whychoose": [
    { "WhyChooseheading": "Experienced Tourist Drivers", "WhyChoosedescription": "Drivers familiar with tourist destinations and highways." },
    { "WhyChooseheading": "Comfortable Seating", "WhyChoosedescription": "Spacious and relaxed seating for long journeys." },
    { "WhyChooseheading": "Multiple Bus Options", "WhyChoosedescription": "Mini, standard, and luxury buses available." },
    { "WhyChooseheading": "Safe & Maintained Vehicles", "WhyChoosedescription": "Regular servicing and safety checks." },
    { "WhyChooseheading": "Flexible Travel Plans", "WhyChoosedescription": "Customizable itineraries and rental durations." },
    { "WhyChooseheading": "Transparent Pricing", "WhyChoosedescription": "Clear and upfront rental costs." },
    { "WhyChooseheading": "Group-Friendly Travel", "WhyChoosedescription": "Entire group travels together comfortably." },
    { "WhyChooseheading": "Trusted Travel Partner", "WhyChoosedescription": "Sanavi Travels is known for reliability." }
  ]
};

const faqData = [
  { question: 'Do you provide tourist bus hire in Pune?', answer: 'Yes, Sanavi Travels offers tourist bus hire services in Pune.' },
  { question: 'Are AC and Non AC buses available?', answer: 'Yes, both AC and Non AC tourist buses are available.' },
  { question: 'Is the service suitable for outstation travel?', answer: 'Yes, tourist buses are ideal for long-distance outstation trips.' },
  { question: 'Can we book buses for corporate tours?', answer: 'Yes, corporate tourist bus services are available.' },
  { question: 'Are drivers included in the rental?', answer: 'Yes, all rentals include experienced drivers.' },
  { question: 'Can we customize the itinerary?', answer: 'Yes, travel plans can be customized.' },
  { question: 'Are buses safe for school trips?', answer: 'Yes, buses are well-maintained and driven responsibly.' },
  { question: 'What seating capacities are available?', answer: 'Mini buses, 32 seater, and 35 seater buses are available.' },
  { question: 'Is advance booking recommended?', answer: 'Yes, advance booking ensures availability.' },
  { question: 'Is this a private group service?', answer: 'Yes, buses are dedicated to your group only.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Kulkarni',
    feedback: 'Excellent tourist bus service in Pune. Very comfortable and well managed.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Neha Deshmukh',
    feedback: 'Best choice for group sightseeing and outstation travel from Pune.',
    rating: 5
  }
];












































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tourist Bus Hire Pune - Sanavi Travels",
  "description": "Sanavi Travels offers tourist buses for hire in Pune for family trips, corporate travel, weddings, picnics, and outstation tours. AC and Non-AC buses, mini buses, 32-seater and 35-seater options are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};







  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Tourist Bus Hire Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book tourist buses for hire in Pune with Sanavi Travels. AC & Non-AC mini buses, 32-seater and 35-seater buses for family trips, corporate travel, weddings, picnics, and outstation tours with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/277.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Touristbushirepune;